export default class ResultadoC3ApiRepository {
    async getAll() {
        const resultados = [
            {
                id: 1,
                fecha: '2023-10-01',
                resultado: 'NO CUBRE PERFIL',
                observaciones: 'Detalle de observaciones A',
            },
            {
                id: 2,
                fecha: '2023-10-02',
                resultado: 'CUBRE PERFIL',
                observaciones: 'Detalle de observaciones B',
            },
            {
                id: 3,
                fecha: '2023-10-03',
                resultado: 'NO CUBRE PERFIL',
                observaciones: 'Detalle de observaciones C',
            },
            {
                id: 4,
                fecha: '2023-10-04',
                resultado: 'CUBRE PERFIL',
                observaciones: 'Detalle de observaciones D',
            },
        ]
        return Promise.resolve(resultados)
    }

    async update() {
        return Promise.resolve(true)
    }
}
